var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loginApps && _vm.loginApps[0])?_c('Grid',{attrs:{"grid":"1"}},_vm._l((_vm.loginApps),function(loginApp,index){return _c('Cta',{key:index,attrs:{"data":{
      title: ("Sign in with <span class='t-capitalize'>" + loginApp + "</span>"),
      toggle: 'icon',
      fn: function () { return _vm.loginWithApp(loginApp); },
    },"theme":"login"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('Icon',{attrs:{"name":loginApp,"size":"s"}})]},proxy:true}],null,true)})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }